// core/MapFactory.ts
import { OpenLayersAdapter } from "../adapters/OpenLayersAdapter";
import { LeafletAdapter } from "../adapters/LeafletAdapter";
import { MapLibreAdapter } from "../adapters/MapLibreAdapter";
import { CesiumAdapter } from "../adapters/CesiumAdapter";
import type { MapType } from "../types/MapTypes";

export function createMapAdapter(type: MapType) {
  switch (type) {
    case "openlayers":
      return new OpenLayersAdapter();
    case "leaflet":
      return new LeafletAdapter();
    case "maplibre":
      return new MapLibreAdapter();
    case "cesium":
      return new CesiumAdapter();
  }
}
